import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Industries from "@/pages/Industries";
import Contact from "@/pages/Contact";
import CaseStudies from "@/pages/CaseStudies";
import Insights from "@/pages/Insights";
import InsightArticle from "@/pages/InsightArticle";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/case-studies" element={<CaseStudies />} />
                    <Route path="/insights" element={<Insights />} />
                    <Route path="/insights/:id" element={<InsightArticle />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
